const CACHE_KEY = 'qaCache';
const SUMMARY_CACHE_KEY = 'summaryCache';
const OVERLAYS_SCREENSHOTS = 'overlays_screenshots';

const cacheAnswer = (questionText, answerText) => {
  const existingCache = JSON.parse(localStorage.getItem(CACHE_KEY)) || [];

  const isDuplicate = existingCache.some((entry) => entry.question === questionText);
  if (isDuplicate) return; // Don't save duplicate questions

  const updatedCache = [{ question: questionText, answer: answerText }, ...existingCache];
  localStorage.setItem(CACHE_KEY, JSON.stringify(updatedCache));
};

const getCache = () => {
  return JSON.parse(localStorage.getItem(CACHE_KEY)) || [];
};

const clearCache = () => {
  localStorage.removeItem(CACHE_KEY);
};

const cacheSummary = (questionText, summaryText, responseScore, responseTo) => {
  const existingCache = JSON.parse(localStorage.getItem(SUMMARY_CACHE_KEY)) || [];

  const isDuplicate = existingCache.some((entry) => entry.question === questionText);
  if (isDuplicate) return;

  const updatedCache = [
    { question: questionText, answer: summaryText, responseScore, responseTo },
    ...existingCache,
  ];
  localStorage.setItem(SUMMARY_CACHE_KEY, JSON.stringify(updatedCache));
};

const getSummaryCache = () => {
  return JSON.parse(localStorage.getItem(SUMMARY_CACHE_KEY)) || [];
};

const clearSummaryCache = () => {
  localStorage.removeItem(SUMMARY_CACHE_KEY);
};

// screenshot caching for overlays
const cacheOverlaysScreenshots = (overlayName, screenshotId) => {
  const existingCache = JSON.parse(localStorage.getItem(OVERLAYS_SCREENSHOTS)) || [];

  const isDuplicate = existingCache.some((entry) => entry.name === overlayName);
  if (isDuplicate) return;

  const updatedCache = [...existingCache, { name: overlayName, screenshot: screenshotId }];
  localStorage.setItem(OVERLAYS_SCREENSHOTS, JSON.stringify(updatedCache));
};

const getCacheOverlaysScreenshots = () => {
  return JSON.parse(localStorage.getItem(OVERLAYS_SCREENSHOTS)) || [];
};

const clearCacheOverlaysScreenshots = () => {
  localStorage.removeItem(OVERLAYS_SCREENSHOTS);
};

export {
  cacheAnswer,
  getCache,
  clearCache,
  cacheSummary,
  getSummaryCache,
  clearSummaryCache,
  cacheOverlaysScreenshots,
  getCacheOverlaysScreenshots,
  clearCacheOverlaysScreenshots,
};
